import { ListActionTarget } from './ListActionTarget';
import { Orderlist } from './OrderList';
import { PriceTier } from './PriceTier';
import { ACTION_COPY, ACTION_MOVE } from '../js/store/constants';
import { UpdateProductOptions } from '../js/store/products/actionsCart';

export type AddOptions = (
    | { readonly target: typeof ListActionTarget.Cart }
    | { readonly target: typeof ListActionTarget.List; readonly list: Orderlist }
) & {
    readonly priceTier?: PriceTier;
};

export type CopyOrMoveOptions = AddOptions & {
    action: typeof ACTION_COPY | typeof ACTION_MOVE;
};

export const isCopyOptions = (options: AddOptions | CopyOrMoveOptions): options is CopyOrMoveOptions => {
    return options !== undefined && 'action' in options && options.action === ACTION_COPY;
};

export const isMoveOptions = (options: AddOptions | CopyOrMoveOptions): options is CopyOrMoveOptions => {
    return options !== undefined && 'action' in options && options.action === ACTION_MOVE;
};

export type TopChartAddOptions = AddOptions & {
    readonly includeAllProducts: boolean;
};

export type SingleAddOptions = (
    | { readonly target: typeof ListActionTarget.Cart }
    | { readonly target: typeof ListActionTarget.List; readonly listId: string }
) & {
    readonly options: UpdateProductOptions;
};

export type SingleCopyOrMoveOptions = SingleAddOptions & {
    action: typeof ACTION_COPY | typeof ACTION_MOVE;
};
export const isSingleCopyOptions = (
    options: SingleAddOptions | SingleCopyOrMoveOptions
): options is SingleCopyOrMoveOptions => {
    return options !== undefined && 'action' in options && options.action === ACTION_COPY;
};

export const isSingleMoveOptions = (
    options: SingleAddOptions | SingleCopyOrMoveOptions
): options is SingleCopyOrMoveOptions => {
    return options !== undefined && 'action' in options && options.action === ACTION_MOVE;
};

export type RenewalAddOptions = (
    | { readonly target: typeof ListActionTarget.Cart }
    | { readonly target: typeof ListActionTarget.List; readonly listId: string }
) & {
    readonly totalValue: number;
};
